import { Toast } from "antd-mobile";
import { ethers } from "ethers";
import useGlobal from "./useGlobal";
import useContract from "./useContract";
import { ExclamationOutline } from "antd-mobile-icons";
import { useEffect, useRef, useState } from "react";
import useWallet from "./Wallet/useWallet";
import useTransaction from "./useTransaction";

import { handlerWalletTxError, date2block } from "../utils/utils";
export default function useEquip({ intl }) {
  const [composeFeeMap, setComposeFeeMap] = useState({});
  const loading = useRef();
  const {
    addTxHashList,
    loadUserInfo,
    showLoading,
    loadMyEquips,
    loadMyCards,
    getTxOptions
  } = useGlobal();
  const {
    getCollectContract,
    getRunContract,

    getNFTApprove,
    setApproveNFT,
    getEqiupContract,
    getQuilityContract,

    getRBCTBalance,
    getRBCTAllowance,
    setRBCTAllowance,

    getRBETBalance,
    getRBETAllowance,
    setRBETAllowance,

    getRBBalance,
    getRBAllowance,
    setRBAllowance,
  } = useContract();
  const timer = useRef();
  useEffect(() => {
    return () => {
      timer.current && clearTimeout(timer.current);
    };
  });
  const deferredFn = (cb, time = 1000) => {
    return new Promise((resolve, reject) => {
      if (cb) {
        // console.log("time", Date.now());
        // timer.current = setTimeout(() => {
        //   console.log("time", Date.now());
        cb(resolve);
        // }, time);
      } else {
        resolve();
      }
    });
  };
  const { sendTransaction } = useTransaction({ intl });
  const { myAccount, provider } = useWallet();
  const reject_transaction_text = intl.formatMessage({
    id: "common.reject_transaction",
    defaultMessage: "拒絕交易",
  });

  // 装上装备
  const toBindEquip = async (equipItem) => {
    showLoading(
      intl.formatMessage({
        id: "components.equip_modal.mount_preparing",
        defaultMessage: "裝備绑定中...",
      }),
      loading.current
    );
    try {
      showLoading(
        intl.formatMessage({
          id: "components.equip_modal.mount_trading",
          defaultMessage: "裝備交易中...",
        }),
        loading.current
      );
      const contract = await getRunContract();
      const gaslimit = await contract.estimateGas.bindEquip(
        equipItem.id
      );
      const opts = await getTxOptions(gaslimit)
      let tx = await contract.bindEquip(equipItem.id, opts);
      Toast.show({
        content: intl.formatMessage({
          id: "common.waiting_tx",
        }),
        icon: "success",
      });
      await addTxHashList(
        "mount_equip",
        tx,
        {
          equip: equipItem,
        },
        {
          success: "components.equip_modal.mount_success",
          fail: "components.equip_modal.mount_fail",
        }
      );
    } catch (e) {
      console.error(e);
      const reason = handlerWalletTxError(e, intl);
      const error = intl.formatMessage({
        id: "components.equip_modal.mount_fail",
        defaultMessage: "绑定失败",
      });

      Toast.show({
        content: error + ": " + reason,
        icon: "fail",
      });
    }
  };
  // 卸下装备
  const toUnbindEquip = async (type) => {
    showLoading(
      intl.formatMessage({
        id: "components.equip_modal.unmount_preparing",
        defaultMessage: "裝備卸下中...",
      }),
      loading.current
    );

    try {
      const contract = await getRunContract();
      const gaslimit = await contract.estimateGas.unbindEquip(type);
      const opts = await getTxOptions(gaslimit)
      let tx = await contract.unbindEquip(type,opts);
      Toast.show({
        content: intl.formatMessage({
          id: "common.waiting_tx",
        }),
        icon: "success",
      });
      await addTxHashList(
        "unmount_equip",
        tx,
        {
          equipType: type,
        },
        {
          success: "components.equip_modal.unmount_success",
          fail: "components.equip_modal.unmount_fail",
        }
      );
    } catch (e) {
      console.log(e);
      const reason = handlerWalletTxError(e, intl);
      const error = intl.formatMessage({
        id: "components.equip_modal.unmount_fail",
        defaultMessage: "卸下失败",
      });
      Toast.show({
        content: error + ": " + reason,
        icon: "fail",
      });
    }
  };

  // 装备 绑定 属性卡
  const toBindQuility = async (equip, card, cardIndex) => {
    showLoading(
      intl.formatMessage({
        id: "components.cards_modal.mount_preparing",
        defaultMessage: "属性卡绑定中...",
      })
    );
    try {
      showLoading(
        intl.formatMessage({
          id: "components.cards_modal.mount_trading",
          defaultMessage: "属性卡交易中...",
        })
      );
      const contract = await getRunContract();
      const gaslimit = await contract.estimateGas.bindCard(
        equip.id,
        card.id,
        cardIndex
      );
      const opts = await getTxOptions(gaslimit)
      let tx = await contract.bindCard(equip.id, card.id, cardIndex, opts);

      Toast.show({
        content: intl.formatMessage({
          id: "common.waiting_tx",
        }),
        icon: "success",
      });

      await addTxHashList(
        "mount_card",
        tx,
        {
          equip,
          card,
          cardIndex,
        },
        {
          success: "components.cards_modal.mount_success",
          fail: "components.cards_modal.mount_fail",
        }
      );
    } catch (e) {
      console.error(e);
      const reason = handlerWalletTxError(e, intl);
      const error = intl.formatMessage({
        id: "components.cards_modal.mount_fail",
        defaultMessage: "绑定失败",
      });
      Toast.show({
        content: error + ": " + reason,
        icon: "fail",
      });
    }
  };

  // 卸下 装备 属性卡
  const toUnBindQuility = async (equip, cardIndex) => {
    if (equip.latestDay && equip.latestDay === date2block(Date.now())) {
      Toast.show({
        content: intl.formatMessage({
          id: "common.can_not_change_card",
        }),
      });
      return;
    }

    showLoading(
      intl.formatMessage({
        id: "components.cards_modal.unmount_preparing",
        defaultMessage: "属性卡卸下中...",
      })
    );
    try {
      const block = provider.getBlock();
      const curDay = parseInt((block.timestamp + 28800) / 86400);
      //查看该卡所绑装备是否正在使用中
      const contract = await getRunContract();

      const date = await contract.getEquipInfo(equip.id);
      showLoading(
        intl.formatMessage({
          id: "components.cards_modal.unmount_trading",
          defaultMessage: "属性卡交易中...",
        })
      );
      if (date.latestDay == curDay) {
        Toast.show({
          content: intl.formatMessage({
            id: "components.cards_modal.unmount_mounting_error",
            defaultMessage: "属性卡正在使用,请明天再试!",
          }),
          icon: "fail",
        });
        return;
      }
      const gaslimit = await contract.estimateGas.unbindCard(
        equip.id,
        cardIndex
      );
      const opts = await getTxOptions(gaslimit)
      let tx = await contract.unbindCard(equip.id, cardIndex, opts);
      Toast.show({
        content: intl.formatMessage({
          id: "common.waiting_tx",
        }),
        icon: "success",
      });
      await addTxHashList(
        "unmount_card",
        tx,
        {
          equip,
          cardIndex,
        },
        {
          success: "components.cards_modal.unmount_success",
          fail: "components.cards_modal.unmount_fail",
        }
      );
      // Toast.show({
      //   content: intl.formatMessage({
      //     id: "components.cards_modal.unmount_success",
      //     defaultMessage: "卸下成功",
      //   }),
      //   icon: "success",
      // });
    } catch (e) {
      console.error(e);
      const reason = handlerWalletTxError(e, intl);
      const error = intl.formatMessage({
        id: "components.cards_modal.unmount_fail",
        defaultMessage: "卸下失败",
      });
      Toast.show({
        content: error + ": " + reason,
        icon: "fail",
      });
    }
  };

  // 合成
  const composeEquips = async (equips, showLoading = () => {}) => {
    console.log("composeEquips", equips);
    if (!equips || equips.length !== 2) {
      Toast.show({
        content: intl.formatMessage({
          id: "components.compose_modal.nums_error",
          defaultMessage: "请选择2个裝備！",
        }),
        icon: <ExclamationOutline />,
      });
      return;
    }
    const equip0 = equips[0];
    const equip1 = equips[1];
    if (equip0.id === equip1.id) {
      Toast.show({
        content: intl.formatMessage({
          id: "components.compose_modal.same_error",
          defaultMessage: "请选择2个不同裝備！",
        }),
        icon: <ExclamationOutline />,
      });
      return;
    }
    if (equip0.equip.level !== equip1.equip.level) {
      Toast.show({
        content: intl.formatMessage({
          id: "components.compose_modal.level_error",
          defaultMessage: "裝備等级必须一致！",
        }),
        icon: <ExclamationOutline />,
      });
      return;
    }
    if (equip0.equip.equipType !== equip1.equip.equipType) {
      Toast.show({
        content: intl.formatMessage({
          id: "components.compose_modal.type_error",
          defaultMessage: "裝備类型必须一致！",
        }),
        icon: <ExclamationOutline />,
      });
      return;
    }

    const price = await composeFee(
      equip0.equip.equipType,
      equip1.equip.ori_level
    );

    await sendTransaction(
      getRBBalance,
      price,
      getNFTApprove,
      setApproveNFT,
      async () => {
        const contract = await getCollectContract();
        const gaslimit = await contract.estimateGas.forgeEquip(
          equip0.id, equip1.id, 
        );
        const opts = await getTxOptions(gaslimit)
        const tx = await contract.forgeEquip(equip0.id, equip1.id, opts);
        Toast.clear();
        showLoading();
      },
      true
    );
  };

  // 合成费用
  const composeFee = async (equipType, level) => {
    if (composeFeeMap[equipType + "_" + level] === undefined) {
      const collectContract = await getCollectContract();
      const fee = await collectContract.getForgeFee(equipType, level);
      composeFeeMap[equipType + "_" + level] = ethers.utils.formatEther(fee);
      setComposeFeeMap({ ...composeFeeMap });
      return ethers.utils.formatEther(fee);
    }

    return composeFeeMap[equipType + "_" + level];
  };

  // 转让
  const transfer = async (type, address, nftId) => {
    console.log("transfer");
    var isAddress = ethers.utils.isAddress(address);
    if (!isAddress) {
      Toast.show({
        content: intl.formatMessage({
          id: "components.tranfer_modal.is_address_error",
          defaultMessage: "地址異常",
        }),
        icon: "fail",
      });
      return;
    }
    showLoading(
      intl.formatMessage({
        id: "components.tranfer_modal.preparing",
        defaultMessage: "轉讓中...",
      })
    );

    try {
      const contract =
        type === 1 ? await getEqiupContract() : await getQuilityContract();
      let tx = await contract["safeTransferFrom(address,address,uint256)"](
        myAccount.account,
        address,
        nftId
      );
      // showLoading(
      //   intl.formatMessage({
      //     id: "components.tranfer_modal.waiting",
      //     defaultMessage: "等待上鏈中...",
      //   })
      // );
      Toast.show({
        content: intl.formatMessage({
          id: "common.waiting_tx",
        }),
        icon: "success",
      });
      // await tx.wait(3);
      await addTxHashList(
        type === 1 ? "tranfer_equip" : "tranfer_card",
        tx,
        {
          address,
          nftId,
          type,
        },
        {
          success: "components.tranfer_modal.success",
          fail: "components.tranfer_modal.fail",
        }
      );
      // await loadUserInfo();

      // await loadMyEquips();
      // await loadMyCards();

      // Toast.show({
      //   content: intl.formatMessage({
      //     id: "components.tranfer_modal.success",
      //     defaultMessage: "轉讓成功！",
      //   }),
      //   icon: "success",
      // });
      // const opts = [
      //   {
      //     type: "delete",
      //     value: nftId,
      //   },
      // ];
      // updateMyEquipsOrMyCards(opts, type === 1 ? "equip" : "card");
    } catch (e) {
      console.error(e);
      let reason = e.reason
        ? e.reason
        : e.code
        ? e.code == 4001
          ? reject_transaction_text
          : e.massage
        : "";
      Toast.show({
        content:
          intl.formatMessage({
            id: "components.tranfer_modal.fail",
            defaultMessage: "轉讓失敗",
          }) +
          ": " +
          reason,
        icon: "fail",
      });
      return Promise.reject(e);
    }
  };

  // 兑换 属性卡
  const toRedeemQuility = async (card, showLoading = () => {}) => {
    await sendTransaction(
      getRBCTBalance,
      card.price0,
      getRBCTAllowance,
      setRBCTAllowance,
      async () => {
        const contract = await getCollectContract();
        const gaslimit = await contract.estimateGas.redeemCard(
          card.collection_id
        );
        const opts = await getTxOptions(gaslimit)
        const tx = await contract.redeemCard(card.collection_id, opts);
        Toast.clear();
        const loading = showLoading();
        await tx.wait();
        loading.close();
        Toast.show({
          content: intl.formatMessage({
            id: "pages.shop.card_modal.success",
            defaultMessage: "正在为您创建NFT卡片,请3分钟后到卡片页面查看",
          }),
          icon: "success",
        });

        return tx;
      },
      true
    );
    deferredFn(async (done) => {
      await loadUserInfo();
      await loadMyCards();
      done();
    });
  };

  // 兑换 装备
  const toRedeemEqiup = async (eqiup, showLoading = () => {}) => {
    await sendTransaction(
      getRBETBalance,
      eqiup.price0,
      getRBETAllowance,
      setRBETAllowance,
      async () => {
        const contract = await getCollectContract();
        const gaslimit = await contract.estimateGas.redeemShoes(
          eqiup.collection_id
        );
        const opts = await getTxOptions(gaslimit)
        let tx = await contract.redeemShoes(eqiup.collection_id,opts);
        Toast.clear();
        const loading = showLoading();
        await tx.wait();
        loading.close();
        Toast.show({
          content: intl.formatMessage({
            id: "pages.shop.equip_modal.success",
            defaultMessage: "正在为您创建装备，请3分钟后到装备页面查看",
          }),
          icon: "success",
        });
        return tx;
      },
      true
    );
    deferredFn(async (done) => {
      await loadUserInfo();
      // await loadMyEquips();
      done();
    });
  };

  // 购买属性卡
  const toBuyQuility = async (card, showLoading = () => {}) => {
    await sendTransaction(
      getRBBalance,
      card.price1,
      getRBAllowance,
      setRBAllowance,
      async () => {
        const contract = await getCollectContract();
        const gaslimit = await contract.estimateGas.buyCard(
          card.collection_id
        );
        const opts = await getTxOptions(gaslimit)
        let tx = await contract.buyCard(card.collection_id, opts);
        Toast.clear();
        const loading = showLoading();
        await tx.wait();
        loading.close();
        Toast.show({
          content: intl.formatMessage({
            id: "pages.shop.card_modal.success",
            defaultMessage: "正在为您创建NFT卡片,请3分钟后到卡片页面查看",
          }),
          icon: "success",
        });
        return tx;
      },

      true
    );
    deferredFn(async (done) => {
      await loadUserInfo();
      await loadMyCards();
      done();
    });
  };
  // 购买 装备
  const toBuyEqiup = async (eqiup, showLoading = () => {}) => {
    await sendTransaction(
      getRBBalance,
      eqiup.price1,
      getRBAllowance,
      setRBAllowance,
      async () => {
        console.log("购买 装备");
        const contract = await getCollectContract();
        const gaslimit = await contract.estimateGas.buyShoes(
          eqiup.collection_id
        );
        const opts = await getTxOptions(gaslimit)
        let tx = await contract.buyShoes(eqiup.collection_id, opts);
        Toast.clear();
        const loading = showLoading();
        await tx.wait();
        loading.close();
        Toast.show({
          content: intl.formatMessage({
            id: "pages.shop.equip_modal.success",
            defaultMessage: "正在为您创建装备，请3分钟后到装备页面查看",
          }),
          icon: "success",
        });
        return tx;
      },

      true
    );
    deferredFn(async (done) => {
      await loadUserInfo();
      // await loadMyEquips();
      done();
    });
  };
  return {
    toBindEquip,
    toUnbindEquip,

    toBindQuility,
    toUnBindQuility,

    composeEquips,
    composeFee,
    transfer,

    toRedeemQuility,
    toRedeemEqiup,
    toBuyQuility,
    toBuyEqiup,
  };
}
